import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import store from '@store';
import { flowType } from '@utility/userInfo';
import { useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import { connect } from 'react-redux';
import {
  pushModifiersGroupData

} from '@reducers/orders';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import Item from './Item/Item';
import { onModifierSelect } from '../ItemModifierHelper';
const isKiosk = flowType() === 'kiosk';
import {
  onClickModifierHelper,
  getPath,
} from '../../../OrderItemDetailHandler';
import { safeJsonParse } from '@utility/helperFunction';
import styles from '../ItemModifierGroup.module.scss';
import { LABEL } from '@veriables';

const ItemModifier = ({
  activeGroupName,
  menuCard,
  menusList,
  menuIndex,
  modifierGroupList,
  modifierGroup,
  modifierData,
  nestedModifierArray,
  // setNestedModifierArray,
  modifiersHashTable,
  modifierGroupsHashTable,
  setSelectedModArray,
  isNestedModifier,
  isModifierRequired,
  collapse,
  selectedModArray,
  count,
  groupCurrentWeight,
  isVerticalLayout,
}) => {
  const params = useParams();
  const { menuItemId, menuTypeId, internalId } = params;
  const [itemInfo, setItemInfo] = useState(menuCard[menuTypeId][menuItemId]);
  const [showNestedIcon, setShowNestedIcon] = useState(isNestedModifier);
  const [max, setMax] = useState(modifierGroup?.maximum ?? Infinity);
  const [disable, setDisable] = useState(() => false);
  // const count = useRef(0);

  const nestedKeyPrefix = useMemo(
    () => nestedModifierArray.join('|'),
    [nestedModifierArray]
  );

  // Ref keeps selectedModArray current without being a useCallback dep,
  // so onClickModifer / onClickHandler stay stable across selectedModArray changes.
  const selectedModArrayRef = useRef(selectedModArray);
  selectedModArrayRef.current = selectedModArray;

  useEffect(() => {
    setMax(modifierGroup?.maximum ?? 0);
  }, [modifierGroup]);

  const onClickModifierCount = (isActive, weight, clickedModifierId) => {
    const { orders } = store.getState();
    const parentPrefix =
      nestedModifierArray.length > 0 ? getPath(nestedModifierArray) + '|' : '';
    const alreadySelected = orders?.modifierData.filter(
      d =>
        d.startsWith(parentPrefix) &&
        (d.endsWith(`-${modifierGroup.id}`) ||
          d.includes(`-${modifierGroup.id}|`))
    );
    const activeSegments = alreadySelected.map(entry => {
      return entry.split('|').find(segment => segment.endsWith(`-${modifierGroup.id}`));
    }).filter(Boolean);
    const uniqueSegments = [...new Set(activeSegments)];

    const getSelectionQuantity = (segment) => {
      const segmentPath = `${parentPrefix}${segment}`;
      const plainCount = alreadySelected.filter(d => d === segmentPath).length;
      const isNested = alreadySelected.some(d => d.startsWith(`${segmentPath}|`));
      return plainCount > 0 ? plainCount : (isNested ? 1 : 0);
    };

    if (modifierGroup.isWeight) {
      // Compute total weight of already-selected modifiers in this group
      const currentTotalWeight = uniqueSegments.reduce((sum, segment) => {
        const modId = Number(segment.split('-')[0]);
        const modLink = modifierGroup.modifierLinks?.find(
          l => Number(l.modifierId) === modId
        );
        const qty = getSelectionQuantity(segment);
        return sum + (modLink?.weight ?? 0) * qty;
      }, 0);

      if (!isActive) {
        count.current = Math.max(0, currentTotalWeight - (weight ?? 0));
        return false;
      }

      if (max === 0) {
        count.current = currentTotalWeight + (weight ?? 0);
        return false;
      }

      const newTotal = currentTotalWeight + (weight ?? 0);
      if (newTotal > max) {
        return true;
      }
      count.current = newTotal;
      return false;
    }

    // Non-weight groups: original count-based logic
    const totalSelections = uniqueSegments.reduce((sum, segment) => {
      return sum + getSelectionQuantity(segment);
    }, 0);

    const clickedSegment = `${clickedModifierId}-${modifierGroup.id}`;
    const qty = getSelectionQuantity(clickedSegment);

    if (!isActive) {
      count.current = Math.max(0, totalSelections - qty);
      return false;
    }

    if (max === 1) {
      count.current = 1;
      return false;
    }

    if (totalSelections >= max && max !== 0) {
      return true;
    }

    const countTemp = totalSelections + 1;
    count.current = countTemp;
    if (countTemp > max) {
      count.current = countTemp - 1;
    }
    return false;
  };

  // 2.
  const onClickModifer = useCallback(
    (isActive, data, isLimitOver, item, key, isGlobalModFuncDisplay, e) => {

      if (e) e.stopPropagation();

      const modDataRaw = window.sessionStorage.getItem('globalMod');
      const modData = modDataRaw ? safeJsonParse(modDataRaw) : null;

      const check = modData?.modifierData?.some(m =>
        m.includes(data.modifierId)
      );

      if (isLimitOver && !check && modifierGroup.isWeight) {
        return true;
      }

      const modifierInfo = modifiersHashTable[data.modifierId];
      const modifierGroupLinks = modifierInfo?.modifierGroupLinks || [];

      if (
        modifierGroupLinks.length > 0 &&
        !sessionStorage.getItem('nestModId')
      ) {
        sessionStorage.setItem('nestModId', data.modifierId);
        sessionStorage.setItem('modGroup', JSON.stringify(modifierGroup));
      }

      if ((!disable && !isLimitOver) || isActive) {
        // setModCount(false);

        const disableItem = onClickModifierCount(isActive, data.weight, data.modifierId);

        if (!disableItem) {
          // For weight groups: onModifierSelect re-reads isActive from the
          // already-dispatched modifierData, causing it to add the weight again
          // (double-count). Save the accurate total set by onClickModifierCount
          // and restore it afterwards so the render uses the correct value.
          const savedWeightCount = modifierGroup.isWeight ? count.current : null;

          const onClickModifier = () =>
            onClickModifierHelper({
              modifier: data.modifierId,
              modifierGroup: modifierGroup.id,
              isActive,
              key,
              nestedModifierArray,
              modifierData,
              params,
            });

          onClickModifier();

          const { modArray, countTemp } = onModifierSelect({
            selectedModArray: selectedModArrayRef.current,
            modifierGroup,
            count: count.current,
            data,
            item,
            nestedModifierArray,
          });

          setSelectedModArray(modArray);
          count.current = savedWeightCount !== null ? savedWeightCount : countTemp;

          return false;
        }

        return true;
      }

      return true;
    },
    [
      modifiersHashTable,
      modifierGroup,
      nestedModifierArray,
      modifierData,
      params,
    ]
  );

  // 1.
  const onClickHandler = useCallback(
    (e, isActive, data, isLimitOver) => {

      if (e.target.closest('.modifierBtn')) {
        e.stopPropagation();
        return;
      }

      const item = modifiersHashTable[data.modifierId];
      if (!item) return;

      const groupId = item.modifierGroupLinks?.[0]?.modifierGroupId;

      const isSlider = getObjectValue(
        () => modifierGroupsHashTable[groupId]?.displayStyle?.slider,
        false
      );

      const modifierGroupLinksLength = getObjectValue(
        () =>
          menuCard?.[menuTypeId]?.[menuItemId]?.menuItem?.modifierGroupLinks
            ?.length,
        2
      );

      const isGlobalModFuncDisplay =
        modifierGroupLinksLength > 0 &&
        menusList?.[menuIndex]?.globalModifierGroupIds?.length > 0;

      if (itemInfo?.menuItem?.outOfStock) return true;
      if (item?.badge === 1 || item?.badge === 6) return true;
      if (isSlider) return true;

      if (!item.outOfStock) {
        const blocked = onClickModifer(
          isActive,
          data,
          isLimitOver,
          item,
          undefined,
          isGlobalModFuncDisplay,
          e
        );

        if (!blocked) {
          showNestedIcon && setShowNestedIcon(prev => !prev);
        }

        return blocked;
      }

      return true;
    },
    [
      modifiersHashTable,
      modifierGroupsHashTable,
      menuCard,
      menuTypeId,
      menuItemId,
      menusList,
      menuIndex,
      itemInfo,
      showNestedIcon,
      onClickModifer,
    ]
  );

  const hasNamedGroups = modifierGroupList.some(
    g => g.groupName && g.groupName !== 'null'
  );

  return (
    <div>
      {modifierGroupList[0]?.items?.length > 0 &&
        modifierGroupList.map((modGroupList, index) => {
          const shouldRender =
            activeGroupName && Object.values(activeGroupName)[0]
              ? activeGroupName[modGroupList.groupName]
              : true;
          const key = `${index}-${modGroupList?.groupName}-${modGroupList?.items?.length}`
          const isNullGroup = modGroupList.groupName === 'null';
          const showOthersLabel = isNullGroup && hasNamedGroups;
          return (
            <div key={key}>
              {(!isNullGroup || showOthersLabel) && shouldRender && (
                <div
                  className={cn(
                    'fw-700 fs-16 px-1',
                    collapse ? 'd-none' : ''
                  )}
                  style={{borderLeft: "5px solid #74A4FF"}}
                >
                  {showOthersLabel ? LABEL().OTHERS : modGroupList.groupName}
                </div>
              )}
              {!collapse && (
                <div className={cn(!shouldRender ? 'd-none' : 'row mx-0 mt-1 pb-1', !isVerticalLayout && styles.modifierGroupOverflow )}                 >
                  {modGroupList?.items?.map(data => {
                    const item = modifiersHashTable[data.modifierId];
                    const name = data.name || item.name;
                    const isLimitOver =
                      modifierGroup.isWeight &&
                      modifierGroup.maximum > 1 &&
                      data?.weight > (modifierGroup.maximum - groupCurrentWeight);
                    // console.log({name});

                    return (
                      <Item // <RenderMods />
                        // key={data.modifierId}
                        key={`${nestedKeyPrefix}-${data.modifierId}`}
                        name={name}
                        onClickHandler={onClickHandler}
                        weight={data.weight}
                        modifierId={data.modifierId}
                        isModifierRequired={isModifierRequired}
                        isLimitOver={isLimitOver}
                        modifierGroupId={modifierGroup.id}
                        isVerticalLayout={isVerticalLayout}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = ({ orders, theme }) => ({
  menusList: orders.menusList,
  menuIndex: orders.menuIndex,
  menuCard: orders.menuCardList,
  modifiersHashTable: orders.modifiersHashTable,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  isNestedModifier: orders.isNestedModifier,
  serverAppTheme: theme.serverAppTheme,
  nestedModifierArray: orders.nestedModifierArray,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      pushModifiersGroupData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(ItemModifier));
